import { useEffect } from 'react';
export class StaleDataNotifier {
  constructor() {
    this.subscribers = new Set();
  }
  subscribe(callback) {
    this.subscribers.add(callback);
    return () => {
      this.subscribers.delete(callback);
    };
  }
  broadcast() {
    this.subscribers.forEach(cb => cb());
  }
}
export const staleDataNotifier = new StaleDataNotifier();
export function useStaleDataNotifier(callback) {
  useEffect(() => staleDataNotifier.subscribe(callback), [callback]);
}